module.exports = __webpack_public_path__ + "static/ufc-unbreakable-ea6208c07d014ff64628e78df50b3068.png";